import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  GetCustomerContract,
  GetCustomerContractParams,
} from "./apiEcms.types";

const getCustomerContract = async (
  { customerId, contractId }: GetCustomerContractParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetCustomerContract>(
    `/customers/${customerId}/contracts/${contractId}`,
    { signal },
  );

  return data;
};

export const useGetCustomerContract = ({
  customerId,
  contractId,
}: GetCustomerContractParams) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.CONTRACT, customerId, contractId, currentGroup],
    queryFn: ({ signal }) =>
      getCustomerContract({ customerId, contractId }, signal),
  });
};
